import React from 'react';
import { motion } from 'framer-motion';
import { getStaticAsset, STATIC_ASSETS, preloadImage } from '../../utils/staticAssets';
const ProductEcosystem1 = () => {
  return (
    <div className="page-container relative">
      <div className="content-container relative z-10 h-full flex items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
            className="flex flex-col justify-center"
          >
              <img
                      src={STATIC_ASSETS.page03}
                      alt="Background"
                      className="w-full h-full object-cover"
                    />
          </motion.div>
      </div>
    </div>
  );
};

export default ProductEcosystem1;